// cspell: ignore autosync
import Struct from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "../control/index.js";
import { ScrcpyOptions1_18 } from "./1_18.js";
import { toScrcpyOptionValue } from "./types.js";
function toSnakeCase(input) {
    return input.replace(/([A-Z])/g, "_$1").toLowerCase();
}
export const ScrcpySetClipboardControlMessage1_21 = new Struct()
    .uint8("type", ScrcpyControlMessageType.SetClipboard)
    .uint64("sequence")
    .int8("paste")
    .uint32("length")
    .string("content", { lengthField: "length" });
export class ScrcpyOptions1_21 extends ScrcpyOptions1_18 {
    constructor(init) {
        super(init);
    }
    getDefaultValue() {
        return {
            ...super.getDefaultValue(),
            clipboardAutosync: true,
        };
    }
    formatServerArguments() {
        // 1.21 changed the format of arguments
        // So `getArgumentOrder()` is no longer needed
        return Object.entries(this.value)
            .map(([key, value]) => [key, toScrcpyOptionValue(value, undefined)])
            .filter((pair) => pair[1] !== undefined)
            .map(([key, value]) => `${toSnakeCase(key)}=${value}`);
    }
    serializeSetClipboardControlMessage(message) {
        return ScrcpySetClipboardControlMessage1_21.serialize(message);
    }
}
//# sourceMappingURL=1_21.js.map